import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, useMap, useMapEvents } from "react-leaflet";
import { useTheme } from "@/context/ThemeContext";

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) { onPick(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6))); },
  });
  return null;
}

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng)) {
      map.setView([lat, lng], Math.max(map.getZoom(), 13), { animate: true });
    }
  }, [lat, lng]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export function LocationPicker({ lat, lng, onPick }) {
  const { theme } = useTheme();
  const nLat = lat === "" || lat == null ? null : Number(lat);
  const nLng = lng === "" || lng == null ? null : Number(lng);
  const hasPin = nLat != null && nLng != null && !Number.isNaN(nLat) && !Number.isNaN(nLng);
  const center = hasPin ? [nLat, nLng] : [52.1, 5.3];
  const tiles = theme === "dark"
    ? { url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", attr: "&copy; OpenStreetMap &copy; CARTO" }
    : { url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", attr: "&copy; OpenStreetMap &copy; CARTO" };

  return (
    <div style={{ height: 240 }} className="overflow-hidden rounded-md border border-border" data-testid="location-picker-map">
      <MapContainer center={center} zoom={hasPin ? 13 : 7} style={{ height: "100%", width: "100%", cursor: "crosshair" }} scrollWheelZoom>
        <TileLayer url={tiles.url} attribution={tiles.attr} />
        <ClickHandler onPick={onPick} />
        {hasPin && <Recenter lat={nLat} lng={nLng} />}
        {hasPin && (
          <CircleMarker center={[nLat, nLng]} radius={10}
            pathOptions={{ color: "#fff", weight: 2, fillColor: "#f97316", fillOpacity: 0.95 }} />
        )}
      </MapContainer>
    </div>
  );
}
